// ── FORM BACKEND SETUP ────────────────────────────────────────────────
// Submissions from both the Contact form and the Pre-Qualification page are
// delivered to your inbox via Formspree (free tier available).
//
// 1. Create a free account at https://formspree.io and add a new form using
//    the recipient email info@888sourcinngltd.co.uk
// 2. Copy the form's endpoint (looks like https://formspree.io/f/abcdwxyz)
// 3. Paste it below, replacing YOUR_FORM_ID. This single value powers every
//    form on the site.
export const FORMSPREE_ENDPOINT = 'https://formspree.io/f/xqeoreyv'
